/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceType } from '../models/ResourceType';

export class ListInventoryResourceTypesResponse {
  'resourceTypes': Array<ResourceType>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceTypes",
      "baseName": "resourceTypes",
      "type": "Array<ResourceType>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListInventoryResourceTypesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

